<template>
  <div @click="toDetailFn" class="content">
    <div class="status-msg">
      <img class="rp-icon" v-if="itemData.presType == 1" src="./../../assets/rp_3.png" alt="图标">
      <img class="rp-icon" v-else src="./../../assets/rp_4.png" alt="图标">
      <div class="name">{{itemData.presType == 1 ? '西' : '中'}}药处方</div>
      <div :class="[itemData.webStatus == 3 || itemData.webStatus == 4 ? 'active' : '', 'status']">{{formatPrescriptionStatus}}</div>
    </div>
    <div class="item">
      <div class="label">就诊人：</div>
      <div class="msg">{{itemData.name}}  {{itemData.sex === 2 ? "女" : (itemData.sex === 1 ? "男" : '')}}  {{itemData.age}}</div>
    </div>
    <div class="item">
      <div class="label">开方医生：</div>
      <div class="msg">{{itemData.doctorName}} {{itemData.departmentName ? `(${itemData.departmentName})` : ''}}</div>
    </div>
    <div class="item">
      <div class="label">临床诊断：</div>
      <div class="msg diagnose">
        <span v-for="(item) in itemData.diagnoseDtoList" :key="item.code">{{item.name}};</span>
      </div>
    </div>
    <div class="item" v-if="(itemData.webStatus == 4 || itemData.webStatus == 5) && !['10002-018','10002-020'].includes(itemData.enterCode)">
      <div class="label">处方金额：</div>
      <div class="msg">
        <span class="symbol">￥</span>
        <span class="price">{{itemData.totalPrice}}</span>
      </div>
    </div>
    <div class="btn-box">
      <div class="time">{{itemData.prescribeTime}}</div>
      <div class="btn">查看详情</div>
      <div v-if="[3, 4].includes(itemData.webStatus) && itemData.isPay !== 0 && !$isInWxMP" class="btn btn-2" @click.stop.prevent="toBuy">
        <template v-if="itemData.webStatus == 3">预约买药</template>
        <template v-if="itemData.webStatus == 4">去支付</template>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrescriptionStatus } from '@/common/js/computed';

import bridgeService from '@/lib/dsbridgeService';

import {
  getOrderJumpUrl
} from '@/api/prescription';
import baseConfig from '@/api/baseConfig';

export default {
  props: {
    itemData: {
      type: Object,
      required: true,
      default: null,
    },
  },
  computed: {
    formatPrescriptionStatus() {
      return formatPrescriptionStatus(this.itemData.webStatus);
    },
  },
  methods: {
    toDetailFn() {
      const url = this.itemData.isExterChannel ? '/prescription-detai' : '/new-prescription-detail';
      this.$router.push({
        path: url,
        query: {
          prescriptionId: this.itemData.prescriptionId,
          isHistory: true,
        },
      });
    },
    toBuy() {
      // 跳转去购买链接
      // const url = `${baseConfig.namiUrl}advanceExpert?from=hospital&prescriptionId=${this.itemData.id}`;
      // // bridgeService.pushViewCotroller(url);
      // window.location.href = url;

      if (this.itemData.webStatus === 3) {
        // 10011-015 双山小程序医保  10011-002 茂名医保移动支付
        // 特定渠道跳转
        if (this.itemData.enterCode === '10011-015' || this.itemData.enterCode === '10011-002') {
          this.$wx.miniProgram.navigateTo({
            url: `/packageMaoMingYiBao/advance/index?bizType=7&prescriptionId=${this.itemData.prescriptionId}`,
          });
        } else {
          this.getOrderJumpUrl();
        }
      } else if (this.itemData.webStatus === 4) {
        this.payOrder();
      }
    },
    payOrder() {
      const targetUrl = encodeURI(`${baseConfig.namiUrl}orderDetail?orderNumber=${this.itemData.orderNumber}`);
      const dataParams = {
        payNo: this.itemData.payNo,
        orderNumber: this.itemData.orderNumber,
        orderInfo: this.itemData.orderInfo,
      };

      bridgeService.orderPay(dataParams, targetUrl, targetUrl);
    },
    getOrderJumpUrl() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...',
      });

      getOrderJumpUrl({
        prescriptionId: this.itemData.prescriptionId || '',
      }).then((res) => {
        if (res && res.code === 200) {
          const url = `${res.data}&from=hospital`;
          window.location.href = url;
          this.$toast.clear();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 4px 15px;
  background-color: #fff;
  border-radius: $regular-border-radius;
  margin-bottom: 12px;
  overflow: hidden;
}

.status-msg {
  @include flex();
  @include font(14px, 20px, $primary-text-color);

  padding: 10px 0;

  .rp-icon {
    width: 22px;
  }

  .name {
    @include font(16px, 22px);

    flex: 1;
    padding-left: 8px;
    font-weight: $font-bold;
  }

  .status {
    @include font(13px, 18px, $regular-text-color);

    &.active {
      color: $brand-color-2;
    }
  }
}

.item {
  @include flex(flex-start);
  @include font(14px, 20px, $primary-text-color);

  padding: 5px 0;

  .label {
    color: $regular-text-color;
    white-space: nowrap;
  }

  .symbol {
    @include font(12px, 16px, $warning-text-color);

    font-weight: $font-bold;
  }

  .price {
    @include font(16px, 16px, $warning-text-color);

    font-weight: $font-bold;
  }
}

.btn-box {
  @include flex(center);

  padding: 11px 0;

  .time {
    @include font(12px, 18px, $info-text-color);

    flex: 1;
  }

  .btn {
    @include font(13px, 28px);

    width: 72px;
    height: 28px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: $secondary-border-radius;
    text-align: center !important;

    &.btn-2 {
      margin-left: 12px;
      background: linear-gradient(151deg, #42e9a4 0%, #01bb6e 100%);
      border: none;
      color: #fff;
    }
  }
}

</style>
